/* eslint-disable flowtype/require-valid-file-annotation */

import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from 'material-ui/styles';
import Button from 'material-ui/Button';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import TextField from 'material-ui/TextField';
import Snackbar from 'material-ui/Snackbar';
import { ValidatorForm } from 'react-form-validator-core';
import { TextValidator} from 'react-material-ui-form-validator';
import Grid from 'material-ui/Grid';

import Signup from './signup.js';

const styles = theme => ({
  root: {
    width: '90%',
  },
  backButton: {
    marginRight: theme.spacing.unit,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
});

class TermOfService extends React.Component {

  constructor(){
    super();
    this.state = {accept:false, fullName:"", companyName:""};
  }

  handleBack = () => {
    window.location.reload();
  };

  handleSnackClose(){
    this.setState({ open: false });
  }

  handleChange= (name)=> event=> {
    this.setState({ [name] : event.target.value });
  }

  handleSubmit =() => {
    if(this.state.fullName!=""){
      if(this.state.companyName!=""){
        this.setState({accept:true});
      } else {
        this.setState({open:true,message:"Please enter your company name"});
      }
    } else {
      this.setState({open:true,message:"Please enter your fullname"});
    }
  }

  handleError=(errors) => {
    if(errors.length>0){
      document.getElementsByName(errors[0].props.name)[0].focus();
    }
  }

  render() {
    const { classes } = this.props;
    const { accept } = this.state;

    return (

      <div className="center">
        <AppBar position="static" color="primary">
          <Toolbar>
            <Typography type="title" color="inherit">
              Eloop SignUp
            </Typography>
          </Toolbar>
        </AppBar>

        {accept ==false ? (
          <div>
            <br/>
            <Typography type="display1">Term of Service</Typography>
            <br/>
            <br/>
            <div>
              <iframe title="terms_of_service" src="./terms_of_service.html" height="300" width="100%"/>
            </div>
            <br/>

            <div>
              By indicating your name in conjunction to clicking the "I Accept" button, <br/>you are hereby accepting Gold Lasso Terms of Service on behalf of yourself or the organization you represent.
            </div>
            <ValidatorForm ref="form" onSubmit={this.handleSubmit}
                onError={this.handleError} >
              <Grid container spacing={24} justify="center">
                <Grid item xs={12} sm={6}>
                  <TextValidator fullWidth className={classes.textField}
                    name="fullName" value={this.state.fullName}
                    validators={['required']}
                    errorMessages={['Please enter your full name']}
                    label="Full Name*"
                    margin="normal" onChange={this.handleChange('fullName')} />
                </Grid>
              </Grid>
              <Grid container spacing={24} justify="center">
                <Grid item xs={12} sm={6}>
                  <TextValidator fullWidth className={classes.textField}
                    name="companyName" value={this.state.companyName}
                    validators={['required']}
                    errorMessages={['Please enter your company name']}
                    label="Company Name*"
                    margin="normal" onChange={this.handleChange('companyName')} />
                </Grid>
              </Grid>
              <Grid container spacing={24}>
                <Grid item xs={12} sm={12}>
                  <br/>
                  <Button onClick={this.handleBack} className={classes.backButton}>
                    I Decline
                  </Button>
                  <Button raised color="primary" type="submit">
                    I Accept
                  </Button>
                  <br/>
                  <br/>
                </Grid>
              </Grid>
            </ValidatorForm>
          </div>
        ) : (
          <div>
            <Signup fullName={this.state.fullName} clientName={this.state.companyName}/>
          </div>
        )}

        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          open={this.state.open}
          autoHideDuration={3000}
          onRequestClose={this.handleSnackClose.bind(this)}
          SnackbarContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={<span id="message-id">{this.state.message}</span>}
        />

      </div>
    );
  }
}

TermOfService.propTypes = {
  classes: PropTypes.object,
};

export default withStyles(styles)(TermOfService);



// WEBPACK FOOTER //
// ./src/components/termofservice.js